module.exports = __webpack_public_path__ + "img/适老化2.204472d9.jpg";